import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import type { ShareBlocksState } from "@/components/patient/ShareBlockSelector";

export function useGenerateShareLink() {
  const [isGenerating, setIsGenerating] = useState(false);

  const generateLink = async (patientId: string, visibleBlocks?: ShareBlocksState) => {
    setIsGenerating(true);
    try {
      const { data, error } = await supabase.functions.invoke("generate-patient-share-link", {
        body: { 
          patient_id: patientId, 
          expires_in_days: 1,
          visible_blocks: visibleBlocks 
        }
      });

      if (error) throw error;

      // Construir URL usando o domínio atual
      const baseUrl = window.location.origin;
      const shareUrl = `${baseUrl}/compartilhar/${data.token}`;

      return shareUrl;
    } catch (error) {
      console.error("Error generating share link:", error);
      toast.error("Erro ao gerar link de compartilhamento");
      throw error;
    } finally {
      setIsGenerating(false);
    }
  };

  return { generateLink, isGenerating };
}
